import { Eye } from "lucide-react"

import { Avatar } from "@/components/tuw/Avatar"
import StatusBadge from "@/components/tuw/StatusBadge"
import { Button } from "@/components/ui/button"

import TypeGlyph from "./TypeGlyph"

// A read-only row for an order another customer granted TO me. "Open" lands on
// the Atrium order page, which renders read-only for anyone who is not the
// order's customer (OrderViewerScope, AU-44).
export default function SharedWithMeRow({ row }) {
  return (
    <div className="mb-2.5 flex items-center gap-[15px] rounded-[13px] border border-border bg-card px-[18px] py-[14px]">
      <div className="grid size-[42px] shrink-0 place-items-center rounded-[10px] border border-border bg-secondary">
        <TypeGlyph type={row.type} className="size-5 text-muted-foreground" strokeWidth={1.8} />
      </div>

      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-[9px]">
          <span className="truncate font-display text-[14.5px] font-bold tracking-[-0.2px] text-foreground">
            {row.title}
          </span>
          <span className="shrink-0 rounded-[5px] border border-border bg-secondary px-1.5 py-0.5 text-[9px] font-bold tracking-[0.06em] text-ink-3 uppercase">
            Read-only
          </span>
        </div>
        <div className="mt-0.5 flex flex-wrap items-center gap-[7px] text-[12px] text-ink-3">
          <Avatar initials={row.ownerInitials} name={row.owner} size={18} />
          <span>
            Shared by <b className="font-semibold text-foreground">{row.owner}</b>
          </span>
          <span className="size-[3px] rounded-full bg-line-2" />
          <span>{row.package}</span>
        </div>
      </div>

      <div className="flex shrink-0 items-center gap-[14px]">
        {row.words != null && (
          <div className="text-right">
            <div className="text-[9.5px] font-bold tracking-[0.06em] text-ink-3 uppercase">Words</div>
            <div className="mt-0.5 text-[13px] font-semibold text-foreground">{row.words.toLocaleString()}</div>
          </div>
        )}
        <div className="text-right">
          <div className="text-[9.5px] font-bold tracking-[0.06em] text-ink-3 uppercase">Status</div>
          <div className="mt-0.5">
            <StatusBadge tier={row.status.tier} label={row.status.label} />
          </div>
        </div>
        {row.openPath && (
          <Button asChild variant="outline" size="sm">
            <a href={row.openPath}>
              <Eye className="size-[14px]" strokeWidth={1.9} />
              Open
            </a>
          </Button>
        )}
      </div>
    </div>
  )
}
